import Cookies from 'universal-cookie';

const auth_key = "asasarmaye_auth"
const support_key = "asasarmaye_support"

const storeLoginToken = (token: string, days: number = 1) => {
    const cookies = new Cookies();
    cookies.set(auth_key, token, {
        path: '/',
        maxAge: (days * 24 * 3600) // for 1 days
    });
}

const storeSupportUserCode = (code: string, days: number = 1) => {
    const cookies = new Cookies();
    cookies.set(support_key, code, {
        path: '/',
        maxAge: (days * 24 * 3600) // for 1 days
    });
}

const getSupportUserCode = () => {
    const cookies = new Cookies();
    return cookies.get(support_key)
}

const getAuthToken = () => {
    const cookies = new Cookies();
    return cookies.get(auth_key)
}

const removeAuthCookies = () => {
    const cookies = new Cookies();
    cookies.remove(auth_key,{
        path: '/',
    })
    cookies.remove(support_key, {
        path: '/',
    })
}

export {storeLoginToken, getAuthToken , storeSupportUserCode, getSupportUserCode, removeAuthCookies};